import React from 'react'


import shape1 from '../../images/story/s-shape1.png'
import shape2 from '../../images/story/s-shape2.png'
import SectionTitle from '../SectionTitle'

const StorySection4 = (props) => {

    const scheduleItems = [
        {
            title: 'Traslado en trajineras',
            description: 'El acceso será por trajinera, en grupos de 20 personas. Los traslados de aprox. 15-20 min, estarán disponibles de 16:00 a 17:40 horas desde la zona de estacionamiento (Hermenegildo Galeana 260, Xochimilco). También puedes llegar caminando (06–10 min) por el puente del embarcadero hacia la Hacienda Zacapa.',
            hour: '04:00 PM',
        },
        {
            title: 'Cóctel de bienvenida',
            description: 'Al desembarcar de las trajineras, te recibiremos con un cóctel y un aperitivo mientras ubicamos tu mesa',
            hour: '04:45 PM',
        },
        {
            title: 'Ceremonia simbólica',
            description: 'La ceremonia comenzará a la hora indicada; te sugerimos llegar con anticipación para disfrutarla desde el inicio.',
            hour: '05:30 PM',
        },
        {
            title: 'Fotos con invitados(as)',
            description: 'Hora de sonreír con una dinámica rápida.',
            hour: '06:10 PM',
        },
        {
            title: 'Brindis',
            description: ' Brindamos, reímos y abrimos la barra libre.',
            hour: '06:30 PM',
        },
        {
            title: 'Cena',
            description: 'Servicio de banquete con sabor a Xochimilco.',
            hour: '06:35 PM',
        },
        {
            title: 'Primer baile',
            description: 'Persignamos la pista: todo comienza con una canción… y a partir de ahí vienen muchas sorpresas.',
            hour: '07:50 PM',
        },
        {
            title: 'Cierre del evento',
            description: 'Gracias por acompañarnos.',
            hour: '01:30 AM',
        }
    ];

    return (
        <section className="wpo-story-section-s4 section-padding" id="story">
            <div className="container">
                <SectionTitle subTitle={''} MainTitle={'Plan del día'} />
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="story-timeline">
                            <div className="round-shape"></div>
                            {scheduleItems.map((item, index) => {
                                const isEven = index % 2 === 0
                                const currentShape = isEven ? shape1 : shape2
                                const isLast = index === scheduleItems.length - 1

                                if (isEven) {
                                    return (
                                        <div key={index} className="row">
                                            <div className="col col-lg-6 col-12">
                                                <div className={`img-holder ${isLast ? 'video-holder' : 'right-align-text'} left-site`}>
                                                    <div className="story-shape-img-1">
                                                        <img src={currentShape} alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col col-lg-6 col-12 text-holder">
                                                <span className="heart">
                                                    <i className="fi flaticon-heart"></i>
                                                </span>
                                                <div className="story-text">
                                                    <span className="date">{item.hour}</span>
                                                    <h3>{item.title}</h3>
                                                    <p>{item.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div key={index} className="row">
                                            <div className="col col-lg-6 col-12 order-lg-1 order-2 text-holder right-heart">
                                                <span className="heart">
                                                    <i className="fi flaticon-heart"></i>
                                                </span>
                                                <div className="story-text right-align-text">
                                                    <span className="date">{item.hour}</span>
                                                    <h3>{item.title}</h3>
                                                    <p>{item.description}</p>
                                                </div>
                                            </div>
                                            <div className="col col-lg-6 col-12 order-lg-2 order-1">
                                                <div className="img-holder right-align-img">
                                                    <div className="story-shape-img-1">
                                                        <img src={currentShape} alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            })}
                            <div className="row">
                                <div className="col offset-lg-6 col-lg-6 col-12 text-holder">
                                    <div className="round-shape-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default StorySection4;